import {SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class StockLevelSearchModel extends SearchModel<any> {
    constructor(injector: Injector) {
        super(injector)
    }

    override getIdentifierField(): string {
        return "outletStockID";
    }
    override isEntityLocalisable(): boolean {
        return false;
    }

}
